<!-- <a matTooltip="{{this.translate.data['TOOLTIPVIEWPROJECTINFO'] | translate}}"  [routerLink]="routerLinkEditProject">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_edit}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPCLONEPROJECT'] | translate}}" (click)="cloneProject()"
        [hidden]="!(icon_clone)">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_clone}}</mat-icon>
</a>
<a matTooltip="{{this.translate.data['TOOLTIPREMOVEPROJECT'] | translate}}" (click)="removeProject()"
        [hidden]="!(icon_delete)">
    <mat-icon aria-hidden="false" aria-label="icon">{{icon_delete}}</mat-icon>
</a> -->

<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" [routerLink]="routerLinkEditProject">Einstellungen</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" (click)="cloneProject()" [hidden]="projectArchived">Kopieren</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;" (click)="archiveProject()" [hidden]="projectArchived">Archivieren</button>
</a>
<a>
    <button mat-raised-button class="btn btn-squirrel pull-left admin-buttons" style="margin-top: 6px;" (click)="updateProject()" [hidden]="projectArchived || !_userRoles.includes('admin')">Projekt updaten</button>
</a>
<a matTooltip="Projekt ist aktualisiert" 
        [hidden]="isUpdProjPossible">
    <mat-icon aria-hidden="false" aria-label="icon" style="margin-top: 15px; color:darkgreen; font-weight: bold;">done_outline</mat-icon>
    {{currentVersion}}
</a>
<a style="margin-top: 10px; color: darkblue; font-size: 13px; font-weight: bold;" [hidden]="!isUpdRunning">
    Update läuft ........
</a>
<a style="margin-top: 10px; color: red; font-size: 13px; font-weight: bold;" [hidden]="!isUpdError">
    {{updErrMsg}}
</a>
